/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/keyfigures'
export default icon
